export function getIndexStatusLabel(status?: string | null): string {
  switch ((status || "").toLowerCase()) {
    case "completed":
      return "已完成";
    case "failed":
      return "索引失败";
    case "processing":
    case "pending":
    default:
      return "索引中";
  }
}

export function getAsrStatusLabel(status?: string | null): string {
  switch ((status || "").toLowerCase()) {
    case "completed":
      return "已完成";
    case "failed":
      return "识别失败";
    case "processing":
    case "pending":
    default:
      return "识别中";
  }
}
